import React from 'react';
import { TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import {
  getValidationErrorProps,
  FormProps,
  getMaxLengthValidationRule,
  getMinLengthValidationRule,
  getRequiredValidationRule,
} from 'util/Form';
import { UserFormValues } from 'store/types/FormValues';

const DEFAULT_PHONE_MIN_LENGTH = 7;
const DEFAULT_PHONE_MAX_LENGTH = 32;

interface PhoneFormItemProps extends FormProps {
  required?: boolean;
  phoneFieldName?: keyof UserFormValues | string;
}

const PhoneFormItem: React.FunctionComponent<PhoneFormItemProps> = ({
  required = false,
  label = 'Phone Number',
  disabled,
  phoneFieldName = 'phone',
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          {...getValidationErrorProps(error)}
          label={label}
          disabled={disabled}
          required={required}
        />
      )}
      name={phoneFieldName}
      control={control}
      rules={{
        required: getRequiredValidationRule('phone number', false, required),
        maxLength: disabled ? undefined : getMaxLengthValidationRule(DEFAULT_PHONE_MAX_LENGTH),
        minLength: disabled ? undefined : getMinLengthValidationRule(DEFAULT_PHONE_MIN_LENGTH),
      }}
    />
  );
};
export default PhoneFormItem;
